// extracted by mini-css-extract-plugin
export var compact = "_n0-2";
export var phoneFrame = "_n0-0";
export var phoneScreen = "_n0-1";